import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ModalWrapper from './ModalWrapper';
import {
  hasFeatureInLocalStorage,
  INBOX_BACKGROUND_REFRESH_FEATURE,
  REFERRAL_REALTIME_UPDATES_FEATURE,
} from '../../global/featureFlags';

const warningStyle = {
  backgroundColor: '#fff7e6',
  border: '1px solid #ffd591',
  borderRadius: '6px',
  color: '#8c4a00',
  marginBottom: '16px',
  padding: '12px 16px',
};

const errorStyle = {
  color: 'red',
};

class ReferralArchiveWarning extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      archiveRecordsResultMessage: '',
      completedArchiveRecord: false,
    };
  }

  archive = async () => {
    const {
      modalType,
      archiveReceivedRecords,
      hideModal,
    } = this.props;

    await archiveReceivedRecords(modalType.data.tokens);
    const { archiveErrorMessage } = this.props;

    this.setState({ completedArchiveRecord: true });
    let message = 'Successfully archived all record(s)';
    if (archiveErrorMessage) {
      this.setState({ error: true });
      message = 'We were unable to archive the selected records. Please try again';
      this.setState({ archiveRecordsResultMessage: message });
      return;
    }

    this.setState({ archiveRecordsResultMessage: message });
    // With inbox_background_refresh on, the archive action requests a background
    // refresh of the inbox table (REQUEST_INBOX_TABLE_REFRESH), so no page reload
    // is needed — the rows update behind the modal while the result message is
    // showing. Off, keep the legacy reload (skipped on the referral page when
    // realtime updates already reconcile the list).
    setTimeout(() => {
      hideModal();
      if (!hasFeatureInLocalStorage(INBOX_BACKGROUND_REFRESH_FEATURE)) {
        const onReferralPage = window.location.pathname === '/app/referred';
        const referralRealtimeEnabled = hasFeatureInLocalStorage(REFERRAL_REALTIME_UPDATES_FEATURE);
        if (!onReferralPage || !referralRealtimeEnabled) {
          window.location.reload();
        }
      }
    }, 2500);
  };

  render() {
    const customContentStyle = {
      width: '45%',
    };

    const errorModalStyle = {
      width: '20%',
    };

    const {
      hideModal, archiveErrorMessage, isLoading, modalType,
    } = this.props;
    const { error, archiveRecordsResultMessage, completedArchiveRecord } = this.state;
    const softBlockStatuses = modalType?.data?.softBlockStatuses || [];

    if (error) {
      return (
        <ModalWrapper
          hideModal={hideModal}
          customContentStyle={errorModalStyle}
          action={hideModal}
          actionName="OK"
          modalTitle="Archive Record"
        >
          <p style={errorStyle}>{ archiveErrorMessage || 'An error has occurred. Please try again' }</p>
        </ModalWrapper>
      );
    }

    return (
      <ModalWrapper
        hideModal={hideModal}
        customContentStyle={customContentStyle}
        action={this.archive}
        actionName="Archive"
        actionButtonDanger
        dismiss="Cancel"
        modalTitle="Archive Records"
        isLoading={isLoading || completedArchiveRecord}
      >
        <div>
          <div style={warningStyle}>
            <strong>These records are currently in referral statuses that typically should not be archived.</strong>
            <br />
            <br />
            {softBlockStatuses.join(', ')}
          </div>

          <span style={{ fontWeight: '600' }}>
            Are you sure you want to archive these records?
          </span>
          <br />
          <br />
          Recipients of this record will still have access to this record. After
          the record is archived,
          {' '}
          {hasFeatureInLocalStorage(INBOX_BACKGROUND_REFRESH_FEATURE)
            ? 'the list will update automatically.'
            : 'the page will automatically refresh.'}
          <br />
          <br />
          {archiveRecordsResultMessage && (
            <p
              style={{
                textAlign: 'center',
                marginBottom: '0px',
                fontStyle: 'italic',
              }}
            >
              {archiveRecordsResultMessage}
            </p>
          )}
        </div>
      </ModalWrapper>
    );
  }
}

ReferralArchiveWarning.defaultProps = {
  archiveErrorMessage: '',
};

ReferralArchiveWarning.propTypes = {
  hideModal: PropTypes.func.isRequired,
  modalType: PropTypes.object.isRequired,
  archiveReceivedRecords: PropTypes.func.isRequired,
  archiveErrorMessage: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

export default ReferralArchiveWarning;
